<div class="mb-3 flex items-center justify-between">
  <h1 class="textTabsColor text-2xl font-bold" i18n="@@PharmaciesRequestsTitle">Pharmacies Requests</h1>
  <a
    routerLink="/admin/pharmacies/create-pharmacy"
    class="add-button flex items-center justify-center gap-2">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
    </svg>
    <span i18n="@@adminPharmaciesAddPharmacyButton">Add Pharmacy</span>
  </a>
</div>
<app-filter
  [filters]="filters()"
  [statuses]="statuses()"
  (toggleSortOrder)="toggleSortOrder()"
  (resetFilters)="resetFilters()"
  (applyFilters)="applyFilters($event)"
  (selectFullName)="selectePharmacyOwner($event)"
  (selectEmployee)="selectEmployee($event)" />

@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="isArabic() ? 'حدث خطأ ما. يرجى المحاولة مرة أخرى.' : 'Something went wrong. Please try again.'" />
}
@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems()"
    [rows]="rows()"
    (toggleDropdown)="toggleDropdown($event)"
    [currentActions]="currentActions()"
    (actionSelected)="onTableAction($event)"
    (actionTrigger)="handleAction($any($event))"
    [emptyContentTitle]="isArabic() ? 'لا يوجد صيدليات' : ' No pharmacies found'" />
}
<!-- <div class="mt-2 overflow-visible rounded-[8px] border border-[#E5E7EB] bg-white shadow-sm">
  <table class="w-full text-left text-sm text-gray-500">
    <thead class="bg-[#F3F4F6] text-xs font-[600] text-[#374151] uppercase">
      <tr>
        <th class="px-6 py-3 text-center" i18n="@@adminPharmaciesTableNickname">Nickname</th>
        <th class="px-6 py-3 text-center" i18n="@@adminPharmaciesTableOwner">Pharmacy Owner</th>
        <th class="px-6 py-3 text-center" i18n="@@adminPharmaciesFilterStatus">Status</th>
        <th
          *hasScope="SCOPES.PHARMACIES.AUTO_COMPLETE_BY_EMPLOYEE_NAME"
          i18n="@@adminpharmaciesListAssignedTo"
          class="px-6 py-3 text-center">
          Assigned To
        </th>
        <th class="px-6 py-3 text-center" i18n="@@adminListPharmaciesCreatedOnFrom">Created On / By</th>
        <th class="px-6 py-3 text-center" i18n="@@adminListPharmaciesCreatedOnFromLastUpdated">Last Updated On / By</th>
        <th class="px-6 py-3 text-center"></th>
      </tr>
    </thead>
    <tbody>
      @if (state() === "loading") {
        <tr>
          <td colspan="7" class="p-8 text-center text-[14px] text-[#6B7280]">
            <app-loading />
          </td>
        </tr>
      } @else {
        @if (pharmacies()?.length === 0) {
          <tr>
            <td colspan="7" class="p-8 text-center text-[14px] text-[#6B7280]" i18n="@@adminPharmaciesNoResults">
              No pharmacies found
            </td>
          </tr>
        } @else {
          @for (pharmacy of pharmacies(); track pharmacy.id; let i = $index; let count = $count) {
            <tr
              (click)="navigateToRequestDetails(pharmacy.id)"
              class="cursor-pointer border-b border-[#E5E7EB] bg-white hover:bg-gray-50">
              <td class="px-6 py-4 text-center text-[13px] font-[500] text-gray-900">
                {{ +pharmacy?.nickName?.length! > 20 ? pharmacy?.nickName?.slice(0, 25) + "...." : pharmacy.nickName }}
              </td>
              <td class="px-6 py-4 text-center text-[13px] text-gray-900">
                {{ pharmacy.pharmacyOwner.fullName }}
              </td>
              <td class="px-6 py-4 text-center">
                <span
                  [class]="getStatusClass(pharmacy.status.titleEn)"
                  class="inline-block w-24 rounded-[4px] px-2 py-0.5 text-center text-[11px] font-[500]">
                  {{ isArabic() ? pharmacy.status.titleAr : isEnglish() ? pharmacy.status.titleEn : "" }}
                </span>
              </td>
              <td
                *hasScope="SCOPES.PHARMACIES.AUTO_COMPLETE_BY_EMPLOYEE_NAME"
                class="px-6 py-4 text-center text-[13px] text-gray-900">
                {{ pharmacy.assignedTo?.fullName || "-" }}
              </td>
              <td class="px-6 py-4 text-center text-[12px] text-[#6B7280]">
                <span class="block">
                  {{ (pharmacy.createdOn | date) || "-" }}
                </span>
                <span>
                  {{ pharmacy.createdBy.fullName }}
                </span>
              </td>
              <td class="px-6 py-4 text-center text-[12px] text-[#6B7280]">
                <span class="block">
                  {{ (pharmacy?.lastModifiedOn | date) || "-" }}
                </span>
                <span>
                  {{ pharmacy?.lastModifiedBy?.fullName }}
                </span>
              </td>
              <td class="relative flex items-center justify-center px-6 py-4 pr-9 text-center">
                <div class="inline-flex items-center justify-center">
                  <button
                    (click)="toggleDropdown(pharmacy.id, $event)"
                    class="flex h-[28px] w-[28px] items-center justify-center rounded-[6px] text-gray-600 hover:cursor-pointer hover:bg-[#E5E7EB] hover:text-gray-900">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <circle cx="12" cy="12" r="1"></circle>
                      <circle cx="12" cy="5" r="1"></circle>
                      <circle cx="12" cy="19" r="1"></circle>
                    </svg>
                  </button>
                  @if (activeDropdownId() === pharmacy.id) {
                    <div
                      [class.top-full]="i < count - 2"
                      [class.mt-1]="i < count - 2"
                      [class.bottom-full]="i >= count - 2"
                      [class.mb-1]="i >= count - 2"
                      [class]="isArabic() ? 'left-[40%]' : 'right-[40%]'"
                      class="absolute z-50 flex w-48 flex-col gap-1 rounded-md border border-gray-200 bg-white p-1 shadow-lg">
                      @for (action of currentActions(); track action.id) {
                        <button
                          *hasScope="getScopeForAction(action)"
                          (click)="handleAction($event, action.id, pharmacy)"
                          class="w-full rounded-[4px] px-3 py-2 text-left text-[13px] text-gray-700 hover:cursor-pointer hover:bg-gray-50">
                          {{ isArabic() ? action.titleAr : action.titleEn }}
                        </button>
                      }
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        }
      }
      @if (state() === "error") {
        <tr>
          <td colspan="7" class="p-8 text-center text-[14px] text-[#C42727]" i18n="@@errorGettingPharmacies">
            Something went wrong. Please try again.
          </td>
        </tr>
      }
    </tbody>
  </table>
</div> -->
<!-- PAGINATION -->
<app-pagination
  [currentPage]="currentPage()"
  [getPageNumbers]="getPageNumbers()"
  [itemsPerPage]="itemsPerPage()"
  [totalPages]="totalPages"
  [startItem]="startItem"
  [endItem]="endItem"
  [totalItems]="totalItems"
  (previousPage)="previousPage()"
  (nextPage)="nextPage()"
  (goToPage)="goToPage($event)"
  (changePageNumber)="changePageNumber($event)"
  (pageSizeChange)="onPageSizeChange()" />
<!-- <div class="mt-4 flex items-center justify-between">
  <div class="flex items-center gap-8">
    <div>
      <span class="mx-4 text-[14px] text-gray-500">{{ isArabic() ? "عدد العناصر" : "Items per page" }}</span>
      <select
        [ngModel]="itemsPerPage()"
        (ngModelChange)="itemsPerPage.set($event); onPageSizeChange()"
        class="rounded-md border border-gray-300 bg-white px-2 py-1 text-[14px]">
        <option [value]="25">25</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
      </select>
    </div>
    <div class="text-[14px]">
      <span i18n="@@adminProductsPaginationShowing">Showing</span>
      <span class="mx-1 text-[#C42727]">{{ startItem }}-{{ endItem }}</span>
      <span i18n="@@adminProductsPaginationOf">of</span>
      <span class="mx-1 text-[#C42727]">{{ totalItems }}</span>
    </div>
  </div>
  <div class="flex items-center gap-1">
    @if (isEnglish()) {
      <button
        title="previous page"
        (click)="previousPage()"
        [disabled]="currentPage() === 1"
        [class.opacity-50]="currentPage() === 1"
        [class.cursor-not-allowed]="currentPage() === 1"
        class="flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border border-[#E5E7EB] hover:cursor-pointer hover:bg-[#f9fafb] disabled:hover:bg-transparent">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
    } @else {
      <button
        title="previous page"
        (click)="previousPage()"
        [disabled]="currentPage() === 1"
        [class.opacity-50]="currentPage() === 1"
        [class.cursor-not-allowed]="currentPage() === 1"
        class="flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border border-[#E5E7EB] hover:cursor-pointer hover:bg-[#f9fafb] disabled:hover:bg-transparent">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    }

    @for (page of getPageNumbers(); track page) {
      @if (page == -1) {
        <span class="px-1 text-[14px]">...</span>
      } @else if (currentPage() === page) {
        <button
          (click)="goToPage(page)"
          class="flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border border-[#E5E7EB] bg-[#C42727] text-[14px] font-[500] text-white hover:cursor-pointer">
          {{ page }}
        </button>
      } @else {
        <button
          (click)="goToPage(page)"
          class="flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border border-[#E5E7EB] text-[14px] font-[500] hover:cursor-pointer hover:bg-[#f9fafb]">
          {{ page }}
        </button>
      }
    }
    @if (isEnglish()) {
      <button
        title="next page"
        (click)="nextPage()"
        [disabled]="currentPage() === totalPages"
        [class.opacity-50]="currentPage() === totalPages"
        [class.cursor-not-allowed]="currentPage() === totalPages"
        class="flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border border-[#E5E7EB] hover:cursor-pointer hover:bg-[#f9fafb] disabled:hover:bg-transparent">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    } @else {
      <button
        title="next page"
        (click)="nextPage()"
        [disabled]="currentPage() === totalPages"
        [class.opacity-50]="currentPage() === totalPages"
        [class.cursor-not-allowed]="currentPage() === totalPages"
        class="flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border border-[#E5E7EB] hover:cursor-pointer hover:bg-[#f9fafb] disabled:hover:bg-transparent">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
    }
  </div>
</div> -->

<!-- ACTIONS -->

@if (assigningEmployeePharmacy()) {
  <app-assign-employee-dialog
    [pharmacyId]="assigningEmployeePharmacy()!.id"
    [nickname]="assigningEmployeePharmacy()!.nickName"
    (close)="closeAssignEmployeeDialog()"
    (employeeAssign)="onEmployeeAssigned($event)"
    [type]="modalType()"
    [prevEmployeeId]="assigningEmployeePharmacy()!.assignedTo?.id" />
}

@if (rejectingPharmacyId()) {
  <app-pharmacy-reason-dialog
    type="reject"
    title="Reject This Pharmacy Request?"
    i18n-title="@@adminPharmacyRejectTitle"
    label="Reason for rejection"
    i18n-label="@@adminPharmacyRejectReasonLabel"
    placeholder="Write your reason here"
    i18n-placeholder="@@adminPharmacyReasonPlaceholder"
    subtitle="Are you sure you want to reject this request?"
    i18n-subtitle="@@adminPharmacyRejectSubtitle"
    confirmButtonText="Save"
    i18n-confirmButtonText="@@adminSaveButton"
    (close)="closeRejectDialog()"
    [pharmacyId]="rejectingPharmacyId()!"
    (rejectionPharmacy)="onReject($event)" />
}

@if (modifyingPharmacyId()) {
  <app-pharmacy-reason-dialog
    type="modify"
    title="Send Modification Request"
    i18n-title="@@adminPharmacyModifyTitle"
    label="Reason for modification"
    i18n-label="@@adminPharmacyModifyReasonLabel"
    placeholder="Write your reason here"
    i18n-placeholder="@@adminPharmacyReasonPlaceholder"
    subtitle="Are you sure you want to send this request?"
    i18n-subtitle="@@adminPharmacyModifySubtitle"
    confirmButtonText="Save"
    i18n-confirmButtonText="@@adminSaveButton"
    (close)="closeModifyDialog()"
    (employeeRequestModification)="onModify($event)"
    [pharmacyId]="modifyingPharmacyId()!" />
}

@if (approvingPharmacyId()) {
  <app-approve-pharmacy-dialog
    [pharmacyId]="approvingPharmacyId()!"
    [pharmacyName]="approvingPharmacyName()!"
    (close)="closeApproveDialog()"
    (success)="onApproveSuccess()" />
}

@if (successRequestModification()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم طلب التعديل بنجاح' : 'modification requested successfully'" />
}

@if (successAssignEmployee()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم تعيين الموظف بنجاح' : 'Employee assigned successfully.'" />
}
